import { type GameCriteria, SEEDING_ROUND, type GameData } from '../../model'
import { isNotEmpty } from '../isEmpty'
import { isNewGameVersion } from './version'

export function hasStarted({ status }: Pick<GameData, 'status'>): boolean {
  return status === 'active' || status === 'finished'
}

export function hasEnded({ status }: Pick<GameData, 'status'>): boolean {
  return status === 'finished'
}

export function hasNotStarted({ status }: Pick<GameData, 'status'>): boolean {
  return !hasStarted({ status })
}

export function hasNotEnded({ status }: Pick<GameData, 'status'>): boolean {
  return !hasEnded({ status })
}

export function getCurrentCriteria({
  currentRound,
  seedingCriteria,
  criteria,
}: Pick<GameData, 'currentRound' | 'seedingCriteria' | 'criteria'>): GameCriteria[] {
  if (currentRound !== SEEDING_ROUND) return criteria
  if (isNotEmpty(seedingCriteria)) return seedingCriteria
  return criteria
}

export function canCriteriaChange(game: GameData): boolean {
  if (game.isDeleted) return false
  if (hasEnded(game)) return false
  if (isNewGameVersion(game)) return true
  return hasNotStarted(game)
}

export function canParticipantsChange(game: GameData): boolean {
  return canCriteriaChange(game)
}
